import { VideoComponentModule } from './../video/video.component.module';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { BestExerciseDetailComponent } from './best-exercise-detail.component';
import { NumberToTimePipeModule } from 'src/app/pipes/number-to-time.pipe';


@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    VideoComponentModule,
    NumberToTimePipeModule
  ],
  exports: [BestExerciseDetailComponent],
  declarations: [BestExerciseDetailComponent],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class BestExerciseDetailComponentModule {}
